import React from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { logger } from "../../utility/logger";
import { ALL_ACCESS, VENDORS } from "../../utility/routingInformation";

export const AdminAccessRequired = () => {
  const { group } = useUser();

  // fetching from the URL
  const { vendor: vendorFromURL } = useParams();

  /** VIKAS --
   * if the user group doesn't belong to the list of valid vendor or admin access group
   * and the vendor from the URL doesn't belong to the list of valid vendors
   * navigate the user back to the dashboard
   */
  if (
    !!vendorFromURL &&
    !(
      VENDORS.some((vendor) => group.includes(vendor)) ||
      (ALL_ACCESS.some((admin) => group.includes(admin)) &&
        VENDORS.includes(vendorFromURL.toUpperCase()))
    )
  ) {
    logger.error("User is not valid to access vendor tools");
    return <Navigate to="/dashboard" replace />;
  }
  logger.log("User is valid to access vendor tools");

  return <Outlet />;
};
